import { supabase } from '@/lib/supabase'
import type { PaymentPlan } from '@/types/domain'

export const paymentPlansRepo = {
  async findByCustomer(customerId: string): Promise<PaymentPlan[]> {
    const { data, error } = await supabase
      .from('payment_plans')
      .select('*')
      .eq('customer_id', customerId)
      .order('created_at', { ascending: false })

    if (error) throw error
    return (data || []) as PaymentPlan[]
  },

  async create(plan: any): Promise<PaymentPlan> {
    const { data, error } = await supabase
      .from('payment_plans')
      .insert(plan as any)
      .select()
      .single()

    if (error) throw error
    return data as PaymentPlan
  },

  async update(id: string, updates: any): Promise<PaymentPlan> {
    const { data, error } = await supabase
      .from('payment_plans')
      .update(updates as never)
      .eq('id', id)
      .select()
      .single()

    if (error) throw error
    return data as PaymentPlan
  },

  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from('payment_plans')
      .delete()
      .eq('id', id)

    if (error) throw error
  },
}
